import { graphql } from '~/gql'

export const GET_FACILITY_PRIMARY_USE_QUERY = graphql(`
  query GetFacilityPrimaryUse($id: ID!) {
    facility: Facility(id: $id) {
      primaryUse
      primaryType
    }
  }
`)
